var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeniedGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224.237,
    height: 257.006,
    viewBox: "0 0 224.237 257.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(-295.655 -515.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(295.655 515.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    transform: "translate(163.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_27_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_28_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10755_",
    transform: "translate(10.762 42.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10757_",
    d: "M383.017,89.959l4.723-8.012L383.847,72.1V66.06L394.31,72.1v6.041l-4.5,7.791a.648.648,0,0,1-.306.271l0,0Z",
    transform: "translate(-377.294 -66.06)",
    fill: "#27c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    d: "M383.017,89.959l4.723-8.012L383.847,72.1V66.06L394.31,72.1v6.041l-4.5,7.791a.648.648,0,0,1-.306.271l0,0Z",
    transform: "translate(-377.794 -66.06)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10756_",
    d: "M388.108,81.314l-4.489,7.776a.67.67,0,0,1-1.213-.115l-4.745-13.7",
    transform: "translate(-377.661 -65.428)",
    fill: "#2a95ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10754_",
    d: "M374.339,26.188l33.622,19.449c.663.383,1.2,1.313,1.2,3.112V89.841c0-.268-.541.656-1.208,1.032L404.82,92.66a2.689,2.689,0,0,1-2.408-.012L368.79,73.2a2.653,2.653,0,0,1-1.2-2.078V30.029a2.62,2.62,0,0,1,1.206-2.067l3.135-1.787A2.689,2.689,0,0,1,374.339,26.188Z",
    transform: "translate(-367.59 -25.897)",
    fill: "#2a95ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    d: "M374.339,26.188l33.622,19.449c.663.383,1.2,1.313,1.2,3.112V89.841c0-.268-.541.656-1.208,1.032L404.82,92.66a2.689,2.689,0,0,1-2.408-.012L368.79,73.2a2.653,2.653,0,0,1-1.2-2.078V30.029a2.62,2.62,0,0,1,1.206-2.067l3.135-1.787A2.689,2.689,0,0,1,374.339,26.188Z",
    transform: "translate(-367.59 -25.897)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10753_",
    d: "M400.176,91.327a2.751,2.751,0,0,0,2.409.014l3.133-1.791c.665-.372,1.207-1.3,1.207-1.03V47.427a3.973,3.973,0,0,0-.381-2.259l-5.522,3.194c.221.372.355.8.355.147V89.6C401.376,91.332,400.883,91.736,400.176,91.327Z",
    transform: "translate(-365.355 -24.575)",
    fill: "#2a95ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_549_",
    d: "M400.176,91.327a2.751,2.751,0,0,0,2.409.014l3.133-1.791c.665-.372,1.207-1.3,1.207-1.03V47.427a3.973,3.973,0,0,0-.381-2.259l-5.522,3.194c.221.372.355.8.355.147V89.6C401.376,91.332,400.883,91.736,400.176,91.327Z",
    transform: "translate(-365.353 -24.575)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M368.79,29.126l33.622,19.449a2.653,2.653,0,0,1,1.2,2.078V76.475h0v15.27c0,.765-.537,1.076-1.2.692L368.79,72.988a2.65,2.65,0,0,1-1.2-2.078V29.819C367.59,29.054,368.126,28.743,368.79,29.126Z",
    transform: "translate(-367.59 -25.687)",
    fill: "#2a95ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(0 143.073)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_3_",
    cx: 112.119,
    cy: 56.967,
    rx: 112.119,
    ry: 56.967,
    transform: "translate(0 0)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows",
    transform: "translate(17.108 176.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_10_",
    d: "M47.346,366.546l8.318,4.8a4.242,4.242,0,0,0,3.839,0l69.992-40.41a1.17,1.17,0,0,0,0-2.216l-8.318-4.8a4.243,4.243,0,0,0-3.839,0L47.346,364.33A1.17,1.17,0,0,0,47.346,366.546Z",
    transform: "translate(-46.551 -323.461)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_7_",
    d: "M97.53,382.558l3.364,1.942a4.243,4.243,0,0,0,3.839,0l58.546-33.8a1.17,1.17,0,0,0,0-2.216l-3.364-1.942a4.242,4.242,0,0,0-3.839,0l-58.545,33.8A1.17,1.17,0,0,0,97.53,382.558Z",
    transform: "translate(-73.065 -335.412)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_62_",
    cx: 30.255,
    cy: 17.468,
    rx: 30.255,
    ry: 17.468,
    transform: "translate(130.062 21.396)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(21.978 40.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M119.124,35.384,61.01,68.941a6.261,6.261,0,0,0-3.13,5.194l0,135a6.967,6.967,0,0,0,2.935,5.55,6.963,6.963,0,0,0,6.273-.232l57.9-33.43a7.4,7.4,0,0,0,3.337-5.781V40.7a6.964,6.964,0,0,0-2.935-5.549A6.964,6.964,0,0,0,119.124,35.384Z",
    transform: "translate(-57.879 -34.512)",
    fill: "#0d6efd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M119.124,35.384,61.01,68.941a6.261,6.261,0,0,0-3.13,5.194l0,135a6.967,6.967,0,0,0,2.935,5.55,6.963,6.963,0,0,0,6.273-.232l57.9-33.43a7.4,7.4,0,0,0,3.337-5.781V40.7a6.964,6.964,0,0,0-2.935-5.549A6.964,6.964,0,0,0,119.124,35.384Z",
    transform: "translate(-57.88 -34.511)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M66.289,256.013a6.876,6.876,0,0,1-5.473-.149,6.969,6.969,0,0,1-2.934-5.55l0-135a5.951,5.951,0,0,1,.842-2.861l5.387,3.056a6.5,6.5,0,0,0-1.554,3.89V253.021C62.555,255.584,64.174,256.8,66.289,256.013Z",
    transform: "translate(-57.879 -75.694)",
    fill: "#0d6efd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M66.289,256.013a6.876,6.876,0,0,1-5.473-.149,6.969,6.969,0,0,1-2.934-5.55l0-135a5.951,5.951,0,0,1,.842-2.861l5.387,3.056a6.5,6.5,0,0,0-1.554,3.89V253.021C62.555,255.584,64.174,256.8,66.289,256.013Z",
    transform: "translate(-57.878 -75.694)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M70.734,77.39a6.53,6.53,0,0,0-2.943,5.1V216.109c0,2.875,2.037,4.052,4.527,2.614l57.913-33.436a7.4,7.4,0,0,0,3.337-5.781V44.967c0-2.12-1.5-2.987-3.338-1.927Z",
    transform: "translate(-63.115 -38.779)",
    fill: "#0d6efd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M76.878,98.122a7.011,7.011,0,0,0-3.172,5.494V218.577c0,2.023,1.42,2.843,3.172,1.831l54.477-31.455a7.036,7.036,0,0,0,3.172-5.494V68.5c0-2.014-1.427-2.838-3.172-1.831Z",
    transform: "translate(-66.241 -51.273)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M76.878,98.122a7.011,7.011,0,0,0-3.172,5.494V218.577c0,2.023,1.42,2.843,3.172,1.831l54.477-31.455a7.036,7.036,0,0,0,3.172-5.494V68.5c0-2.014-1.427-2.838-3.172-1.831Z",
    transform: "translate(-66.241 -51.273)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M130.512,181.842V68.18L76.878,99.149a7.011,7.011,0,0,0-3.172,5.494V218.305l53.634-30.969A7.036,7.036,0,0,0,130.512,181.842Z",
    transform: "translate(-66.241 -52.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(21.529 16.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M127.389,87.739l9.655-5.575c.576-.333,1.043-.1,1.043.528a2.236,2.236,0,0,1-1.043,1.732L127.389,90c-.576.333-1.043.1-1.043-.528A2.238,2.238,0,0,1,127.389,87.739Z",
    transform: "translate(-115.582 -75.768)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M162.588,73.692c.541-.312.978-.059.978.565a2.163,2.163,0,0,1-.978,1.695c-.541.312-.978.059-.978-.565A2.162,2.162,0,0,1,162.588,73.692Z",
    transform: "translate(-134.213 -71.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M170.891,68.905c.541-.312.978-.059.979.565a2.162,2.162,0,0,1-.979,1.695c-.541.312-.978.059-.978-.565A2.163,2.163,0,0,1,170.891,68.905Z",
    transform: "translate(-138.6 -68.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M104.5,107.233c.541-.312.979-.059.979.565a2.163,2.163,0,0,1-.978,1.695c-.541.312-.979.059-.979-.565A2.163,2.163,0,0,1,104.5,107.233Z",
    transform: "translate(-103.524 -89.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M112.806,102.445c.541-.312.978-.059.978.565a2.163,2.163,0,0,1-.978,1.695c-.541.312-.979.059-.979-.565A2.163,2.163,0,0,1,112.806,102.445Z",
    transform: "translate(-107.911 -86.492)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Window_2",
    transform: "translate(43.179 60.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_10_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_11_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M104.783,273.978V153.4a4.666,4.666,0,0,1,.691-2.3l-2.943-1.693a4.765,4.765,0,0,0-.7,2.311l0,120.556a1.545,1.545,0,0,0,.885,1.413c-.275-.158.052.034.082.049s2.28,1.319,2.752,1.589A1.541,1.541,0,0,1,104.783,273.978Z",
    transform: "translate(-101.826 -115.455)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(2.954 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M109.942,239.414a1.346,1.346,0,0,1-1.346-1.339l0-4.337V117.5a4.855,4.855,0,0,1,2.194-3.8L166.45,81.741a1.876,1.876,0,0,1,.907-.283.971.971,0,0,1,.416.09.949.949,0,0,1,.167.094c.389.258.465.66.465,1.227V203.433a4.854,4.854,0,0,1-2.194,3.8l-51.887,29.812-3.776,2.223a1.3,1.3,0,0,1-.607.148Z",
    transform: "translate(-108.355 -81.22)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M167.089,81.43a.727.727,0,0,1,.324.071.673.673,0,0,1,.117.066l.023.016c.29.192.347.519.347,1.02V203.167a4.66,4.66,0,0,1-2.073,3.59L113.939,236.57l-.009.005-3.749,2.207a1.08,1.08,0,0,1-.507.126,1.107,1.107,0,0,1-1.107-1.1V117.23a4.66,4.66,0,0,1,2.073-3.59L166.3,81.683a1.648,1.648,0,0,1,.789-.252m0-.477a2.1,2.1,0,0,0-1.025.315L110.4,113.226a5.12,5.12,0,0,0-2.313,4V237.808a1.582,1.582,0,0,0,1.585,1.578,1.562,1.562,0,0,0,.728-.181l3.774-2.221h0l51.887-29.812a5.109,5.109,0,0,0,2.313-4V82.6a1.542,1.542,0,0,0-.561-1.418,1.173,1.173,0,0,0-.208-.119,1.2,1.2,0,0,0-.518-.112Z",
    transform: "translate(-108.088 -80.953)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4705_",
    d: "M163.538,79.4l-55.66,31.958a4.743,4.743,0,0,0-1.627,1.715l-2.936-1.7a4.617,4.617,0,0,1,1.607-1.687L160.588,77.73a1.625,1.625,0,0,1,1.679-.137c.414.254,2.332,1.344,2.819,1.606A1.671,1.671,0,0,0,163.538,79.4Z",
    transform: "translate(-102.613 -77.418)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_551_",
    transform: "translate(5.404 6.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4693_",
    transform: "translate(0 28.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4697_",
    d: "M113.283,160.965v-.728a.468.468,0,0,1,.139-.365l.038-.022c.076-.044.139.047.139.2v.728a.468.468,0,0,1-.139.365l-.038.022C113.345,161.215,113.283,161.123,113.283,160.965Z",
    transform: "translate(-113.283 -156.39)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4696_",
    d: "M114.621,159.6v-1.257a.466.466,0,0,1,.139-.365l.039-.023c.076-.044.139.047.139.2v1.257a.466.466,0,0,1-.139.365l-.039.022C114.683,159.847,114.621,159.756,114.621,159.6Z",
    transform: "translate(-113.99 -155.389)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4695_",
    d: "M115.962,158.233v-1.786a.468.468,0,0,1,.139-.365l.038-.022c.076-.044.139.047.139.2v1.786a.468.468,0,0,1-.139.365l-.038.022C116.024,158.482,115.962,158.39,115.962,158.233Z",
    transform: "translate(-114.698 -154.388)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4694_",
    d: "M117.3,156.007v-3.083a.465.465,0,0,1,.139-.364l.039-.022c.077-.044.139.048.139.205v3.082a.468.468,0,0,1-.139.365l-.038.022C117.362,156.256,117.3,156.164,117.3,156.007Z",
    transform: "translate(-115.405 -152.527)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4557_",
    transform: "translate(2.82 27.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4638_",
    d: "M120.046,155.137a.153.153,0,0,1-.019-.092v-.452l-.708.409c-.039.022-.058,0-.058-.063v-.162a.5.5,0,0,1,.007-.089.87.87,0,0,1,.025-.087l.753-2.055a.46.46,0,0,1,.036-.08.134.134,0,0,1,.049-.045l.1-.056c.03-.018.051-.018.065,0a.17.17,0,0,1,.02.1v1.581l.157-.091c.03-.017.05-.018.063,0a.186.186,0,0,1,.018.1v.108a.3.3,0,0,1-.018.113.14.14,0,0,1-.063.068l-.157.091v.452a.273.273,0,0,1-.019.114.158.158,0,0,1-.066.07l-.119.068C120.08,155.15,120.059,155.151,120.046,155.137Zm.028-.957v-1.128l-.514,1.424Z",
    transform: "translate(-119.261 -151.47)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4558_",
    d: "M122.476,153.392a1.487,1.487,0,0,1-.208-.924,2.944,2.944,0,0,1,.209-1.163,1.424,1.424,0,0,1,.586-.706.806.806,0,0,1,.284-.108.314.314,0,0,1,.219.032.043.043,0,0,1,.02.04.207.207,0,0,1-.009.052l-.065.236a.1.1,0,0,1-.027.052.046.046,0,0,1-.029,0,.405.405,0,0,0-.362.058.987.987,0,0,0-.4.487,2.207,2.207,0,0,0-.145.86,1.184,1.184,0,0,0,.141.7c.093.116.222.125.386.031a1.036,1.036,0,0,0,.174-.126.873.873,0,0,0,.139-.153v-.735l-.295.17c-.03.018-.05.018-.063,0a.175.175,0,0,1-.018-.1v-.1a.284.284,0,0,1,.018-.115.146.146,0,0,1,.063-.066l.471-.272c.033-.019.056-.018.07,0a.214.214,0,0,1,.021.117V152.7a.475.475,0,0,1-.007.093.224.224,0,0,1-.029.071,1.518,1.518,0,0,1-.559.553C122.81,153.565,122.614,153.557,122.476,153.392Z",
    transform: "translate(-120.85 -150.485)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_723_",
    transform: "translate(51.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4554_",
    d: "M224.768,91.757c-.09-.132-.2-.168-.316-.1l-2.391,1.38a1.214,1.214,0,0,0-.368.966v1.788a1.04,1.04,0,0,0,.139.57.32.32,0,0,0,.128.117.2.2,0,0,0,.188-.015l2.392-1.38a1.215,1.215,0,0,0,.368-.966V92.326A1.044,1.044,0,0,0,224.768,91.757Zm-2.85,4.372a.514.514,0,0,1-.051-.262V94.079a.954.954,0,0,1,.28-.736l2.392-1.38a.111.111,0,0,1,.1-.013.1.1,0,0,1,.041.036.512.512,0,0,1,.051.261v1.788a.954.954,0,0,1-.28.737l-2.391,1.38A.1.1,0,0,1,221.918,96.129Z",
    transform: "translate(-221.692 -91.623)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_",
    transform: "translate(0.406 1.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4553_",
    d: "M223.883,94.381V96.5l-1.288.744a.134.134,0,0,1-.041.014.375.375,0,0,0,0-.072V95.577a.732.732,0,0,1,.208-.547Z",
    transform: "translate(-222.553 -94.381)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_",
    transform: "translate(3.169 0.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    d: "M228.575,92.987c.088-.052.159.2.159.57v.332a1.323,1.323,0,0,1-.162.774l-.162.109,0-1.691Z",
    transform: "translate(-228.411 -92.981)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_703_",
    transform: "translate(6.592 25.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_719_",
    transform: "translate(1.084 2.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_722_",
    d: "M130.38,150.718a1.083,1.083,0,0,1-.411.87c-.227.131-.411-.046-.411-.4a1.084,1.084,0,0,1,.411-.87C130.2,150.191,130.38,150.368,130.38,150.718Z",
    transform: "translate(-129.558 -150.279)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_717_",
    transform: "translate(0.52 1.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_718_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4441_",
    d: "M129.336,148.048a2.478,2.478,0,0,0-.956,1.434c-.037.128-.018.25.043.288h0c.078.049.193-.052.239-.214a1.742,1.742,0,0,1,.673-1.013.435.435,0,0,1,.673.236c.046.108.162.077.24-.063h0a.425.425,0,0,0,.043-.338A.619.619,0,0,0,129.336,148.048Z",
    transform: "translate(-128.361 -147.934)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_705_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_710_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_713_",
    d: "M128.754,145.824a3.845,3.845,0,0,0-1.467,2.088c-.046.136-.033.273.034.316h0c.075.048.184-.046.235-.2a3.131,3.131,0,0,1,1.2-1.707.8.8,0,0,1,1.2.325c.051.1.16.064.235-.071h0a.408.408,0,0,0,.034-.354A.974.974,0,0,0,128.754,145.824Z",
    transform: "translate(-127.26 -145.642)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_553_",
    transform: "translate(24.24 14.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_701_",
    d: "M165.609,130.546a.227.227,0,0,1-.024.1.147.147,0,0,1-.055.067l-.117.067a.042.042,0,0,1-.055,0,.092.092,0,0,1-.024-.071v-2.44l-.466.814a.111.111,0,0,1-.057.059.047.047,0,0,1-.053-.014l-.068-.1a.124.124,0,0,1-.016-.08.246.246,0,0,1,.031-.1l.615-1.081a.192.192,0,0,1,.045-.057.389.389,0,0,1,.047-.032l.117-.067a.041.041,0,0,1,.055,0,.093.093,0,0,1,.024.071v2.861Z",
    transform: "translate(-164.675 -125.177)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_665_",
    d: "M167.792,128.832a.042.042,0,0,1,.055,0,.1.1,0,0,1,.022.073v.3a.218.218,0,0,1-.022.1.147.147,0,0,1-.055.067l-.194.112a.037.037,0,0,1-.053-.006.093.093,0,0,1-.024-.071v-.3a.232.232,0,0,1,.024-.1.136.136,0,0,1,.053-.065Zm0,1.55a.042.042,0,0,1,.055,0,.1.1,0,0,1,.022.073v.3a.214.214,0,0,1-.022.1.147.147,0,0,1-.055.068l-.194.112a.037.037,0,0,1-.053-.006.09.09,0,0,1-.024-.07v-.3a.229.229,0,0,1,.024-.1.135.135,0,0,1,.053-.065Z",
    transform: "translate(-166.179 -125.823)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_556_",
    d: "M169.91,127.974a.042.042,0,0,1-.055,0,.093.093,0,0,1-.024-.071v-.611l-.9.52a.042.042,0,0,1-.055,0,.1.1,0,0,1-.024-.071v-.159a.436.436,0,0,1,.01-.079.569.569,0,0,1,.031-.1l.908-2.357a.533.533,0,0,1,.051-.107.164.164,0,0,1,.061-.063l.116-.068a.042.042,0,0,1,.055,0,.092.092,0,0,1,.024.07v1.852l.247-.142a.041.041,0,0,1,.055,0,.091.091,0,0,1,.024.07v.159a.222.222,0,0,1-.024.1.145.145,0,0,1-.055.067l-.247.142v.611a.227.227,0,0,1-.024.1.147.147,0,0,1-.055.067Zm-.078-1.083v-1.249l-.624,1.609Z",
    transform: "translate(-166.881 -123.696)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    d: "M172.915,125.413a.607.607,0,0,0,.041.117.176.176,0,0,0,.076.083.235.235,0,0,0,.137.011.7.7,0,0,0,.221-.092.8.8,0,0,0,.168-.13.886.886,0,0,0,.143-.187,1.06,1.06,0,0,0,.094-.228.937.937,0,0,0,.037-.272.559.559,0,0,0-.035-.221.182.182,0,0,0-.092-.107.219.219,0,0,0-.141,0,.657.657,0,0,0-.174.073l-.241.14a.043.043,0,0,1-.053-.006.093.093,0,0,1-.024-.071v-.159a.243.243,0,0,1,.016-.082c.012-.029.022-.055.029-.076l.519-1.159-.828.478a.041.041,0,0,1-.055,0,.09.09,0,0,1-.024-.07v-.159a.227.227,0,0,1,.024-.1.14.14,0,0,1,.055-.067l1.133-.655a.044.044,0,0,1,.055,0,.11.11,0,0,1,.022.073v.159a.271.271,0,0,1-.014.085.723.723,0,0,1-.037.094l-.509,1.14a.6.6,0,0,1,.262-.082.292.292,0,0,1,.206.062.439.439,0,0,1,.131.208,1.094,1.094,0,0,1,.047.348,1.64,1.64,0,0,1-.057.438,1.813,1.813,0,0,1-.153.389,1.6,1.6,0,0,1-.227.319,1.19,1.19,0,0,1-.278.227.824.824,0,0,1-.333.124.327.327,0,0,1-.229-.05.331.331,0,0,1-.137-.172.776.776,0,0,1-.047-.259.179.179,0,0,1,.019-.081.11.11,0,0,1,.043-.053l.133-.077a.04.04,0,0,1,.051,0A.1.1,0,0,1,172.915,125.413Z",
    transform: "translate(-168.886 -122.461)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(128.259 71.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_26_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom_8_",
    transform: "translate(23.277 61.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3647_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3652_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0 46.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3732_",
    transform: "translate(5.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3734_",
    d: "M352.232,353.2c-.134-2.135-1.081-22.641-1.081-22.641l10.632,7.377c-1.857,12.3-2.265,15.067-2.344,17.12h0a1.672,1.672,0,0,1,.049.527c-.057,2.438-3.027,3.711-5.356,5.3a43.485,43.485,0,0,1-6.286,3.7c-1.684.76-5.075.783-5.475-.225a64.164,64.164,0,0,0,8.38-6.335C351.831,356.953,352.392,355.759,352.232,353.2Z",
    transform: "translate(-342.37 -330.557)",
    fill: "#ffa8a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 23.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M331.985,401.821a1.976,1.976,0,0,0,.378,2.109,10.083,10.083,0,0,0,6.994,1.591,12.74,12.74,0,0,0,6.816-2.425c1.416-1.071,3.4-2.582,4.984-2.885a9.953,9.953,0,0,0,3.55-1.3c.477-.416.448-2.3.448-2.3Z",
    transform: "translate(-331.705 -389.36)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3729_",
    d: "M353.92,381.23a.55.55,0,0,1,.519.448c.1.52.184,2.029.4,2.882a14.224,14.224,0,0,1,.255,4.574c-.21.961-2.611,1.6-4.147,2.119a19.822,19.822,0,0,0-5,2.847,15.074,15.074,0,0,1-7.4,2.456c-3.469,0-5.7-.912-6.369-2.086-.831-1.453-.141-2.278,3.877-3.948.761-.316,3.439-1.744,4.352-2.263a13.841,13.841,0,0,0,5.857-5.934c.137-.3.153-.634.459-.781a2.968,2.968,0,0,1,1.152-.006,6.921,6.921,0,0,1,1.908.567c.531.246,1.284.534,1.26,1.173a2.029,2.029,0,0,1-.163.649c-.051.13-.091.3.03.382s.269-.007.375-.092a9.9,9.9,0,0,0,1.1-1.19,3.828,3.828,0,0,1,.642-.591,7.006,7.006,0,0,0,.69-.4C353.955,381.811,353.9,381.53,353.92,381.23Z",
    transform: "translate(-331.721 -381.23)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M335.244,401.514c5.015.393,6.54,3.313,6.719,5.109a12.615,12.615,0,0,1-3.579.65c-3.469,0-5.841-.912-6.512-2.087C331.089,403.816,331.66,402.727,335.244,401.514Z",
    transform: "translate(-331.565 -391.947)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(6.67 3.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 3.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M350.241,399.461a.253.253,0,0,0,.156-.05.219.219,0,0,0,.041-.322,6.089,6.089,0,0,0-4.508-1.736.235.235,0,0,0-.223.25.239.239,0,0,0,.266.207,5.64,5.64,0,0,1,4.079,1.565A.253.253,0,0,0,350.241,399.461Z",
    transform: "translate(-345.707 -397.337)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(2.186 2.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M354.875,397.027a.253.253,0,0,0,.156-.05.219.219,0,0,0,.041-.322,6.074,6.074,0,0,0-4.508-1.736.234.234,0,0,0-.222.25.237.237,0,0,0,.266.207,5.633,5.633,0,0,1,4.079,1.565A.248.248,0,0,0,354.875,397.027Z",
    transform: "translate(-350.341 -394.903)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(4.215 1.447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M359.177,394.237a.256.256,0,0,0,.156-.05.219.219,0,0,0,.041-.322,6.094,6.094,0,0,0-4.508-1.736.235.235,0,0,0-.223.249.238.238,0,0,0,.266.207,5.643,5.643,0,0,1,4.079,1.564A.25.25,0,0,0,359.177,394.237Z",
    transform: "translate(-354.643 -392.114)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(5.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M362.508,391.2a.254.254,0,0,0,.153-.048.219.219,0,0,0,.046-.321,6.23,6.23,0,0,0-4.925-1.765.234.234,0,0,0-.222.249.241.241,0,0,0,.266.207,5.782,5.782,0,0,1,4.492,1.588A.247.247,0,0,0,362.508,391.2Z",
    transform: "translate(-357.559 -389.047)",
    fill: "#f0f0f0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(32.711 50.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3661_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3728_",
    d: "M400.918,341.359,412.009,339c.292,6.749.116,14.934.35,21.269.044,1.192.673,9.248.324,11.724-.524,3.719-5.6,3.477-6.016,1.288s-.786-11.543-.869-12.513c-.236-4.058-2.591-10.878-4.244-18.1C401.473,342.314,401,341.7,400.918,341.359Z",
    transform: "translate(-400.918 -339.002)",
    fill: "#ffa8a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(3.942 20.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M409.306,413.057a8.951,8.951,0,0,0,1.191,4.917,3.944,3.944,0,0,0,4.186,1.45c1.708-.31,3.921-1.223,4.493-3.071a10.356,10.356,0,0,0,.243-5.15Z",
    transform: "translate(-409.292 -397.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    d: "M416.751,382.453c.695.073.765,2.984,1.031,5.906.285,3.132,1.3,4.46,1.564,7.029.3,2.935.066,4.233-1.2,5.955s-5.52,3.3-7.461.7c-1.582-2.122-1.545-4.41-1.256-7.319a64.209,64.209,0,0,0,.5-7.414c-.034-2.191-.418-4.231.2-4.452.032.323.058.732.092,1.048.026.243.041,1.429.431,1.455a3.957,3.957,0,0,0,.046-.823.885.885,0,0,1,.224-.7,2.713,2.713,0,0,1,1.1-.356c.691-.093,1.386-.173,2.085-.2.348-.015.7-.017,1.045,0a3.135,3.135,0,0,1,.878.141.588.588,0,0,1,.364.31.824.824,0,0,1,.021.335,2.113,2.113,0,0,0,.059.6c.022.087.085.195.186.177a.171.171,0,0,0,.122-.172c.019-.352-.021-.61-.02-1.021,0-.19-.024-.449-.017-.64S416.757,382.64,416.751,382.453Z",
    transform: "translate(-409.276 -382.453)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M419.477,412.334a6.416,6.416,0,0,1-1.13,4.4c-1.262,1.722-5.857,3.3-7.8.692a7.447,7.447,0,0,1-1.24-4.315C410.633,411.211,417.608,410.605,419.477,412.334Z",
    transform: "translate(-409.294 -397.701)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(1.224 4.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(0.452 6.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M413.1,407.359a.292.292,0,0,0,.087-.017,11.638,11.638,0,0,1,6.035-.319.268.268,0,0,0,.318-.157.223.223,0,0,0-.182-.276,12.055,12.055,0,0,0-6.376.339.214.214,0,0,0-.136.294A.267.267,0,0,0,413.1,407.359Z",
    transform: "translate(-412.83 -406.304)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(0.346 4.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M419.04,402.264a.257.257,0,0,0,.226-.142.218.218,0,0,0-.149-.291,10.109,10.109,0,0,0-6.366.288.211.211,0,0,0-.123.3.282.282,0,0,0,.344.107,9.682,9.682,0,0,1,5.958-.275A.291.291,0,0,0,419.04,402.264Z",
    transform: "translate(-412.604 -401.428)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(0.155 2.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M418.743,397.817a.258.258,0,0,0,.224-.139.215.215,0,0,0-.142-.292,9.109,9.109,0,0,0-6.492.266.209.209,0,0,0-.1.3.281.281,0,0,0,.351.088,8.679,8.679,0,0,1,6.047-.244A.292.292,0,0,0,418.743,397.817Z",
    transform: "translate(-412.199 -396.906)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M418.465,392.944a.259.259,0,0,0,.223-.136.214.214,0,0,0-.137-.294,9.514,9.514,0,0,0-6.541.327.209.209,0,0,0-.109.3.276.276,0,0,0,.349.095,9.088,9.088,0,0,1,6.1-.312A.3.3,0,0,0,418.465,392.944Z",
    transform: "translate(-411.871 -392.059)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3654_",
    d: "M386.874,231.4c.608,11.364,1.184,39.63,1.184,39.63a67.535,67.535,0,0,1,1.644,9.777c.474,7.2.587,19.977.587,19.977s-4.662,1.56-7.927.385c0,0-5.373-21.046-6.593-26.216-1.454-6.157-3.014-17.687-3.014-17.687l-1.663,15.245a46.628,46.628,0,0,1,.057,9.638c-.371,3.29-2.565,18.3-2.565,18.3s-4.48,1.859-8.436-.1c0,0-1.3-25.116-1.468-28.141-.608-11.246-.263-40.912-.083-40.806h28.279Z",
    transform: "translate(-345.708 -231.403)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M413.9,273.994a108.644,108.644,0,0,1-.924-10.935c-.562-8.966-1.332-21.244-2.8-28.2l-.461.1c1.456,6.923,2.224,19.181,2.786,28.133.362,5.772.623,9.942.941,11.037.859,2.957,2.848,14.226,3.255,28.7.191-.05.348-.1.468-.131C416.751,288.232,414.759,276.962,413.9,273.994Z",
    transform: "translate(-372.856 -233.229)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M380.109,270.031l-1.315-11.924a11.406,11.406,0,0,1-6.539-2.55s.346,2.434,5.2,3.874l1.483,9.922-.431,15.619Z",
    transform: "translate(-353.063 -244.164)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top_20_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(0 26.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(2.118 18.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M286.839,197.669a1.635,1.635,0,0,0,.658.4l1.129.447a1.979,1.979,0,0,1,1.136.856l.433.58a1.189,1.189,0,0,0,.809.567,4.224,4.224,0,0,0,1.082.059,4.676,4.676,0,0,0,.785.713c.453.331,1.138,1.454,2.428,1.568a5.383,5.383,0,0,0,2.051-.15l-4.811-7.577-4.908.638-.722,1.151C286.729,197.206,286.587,197.374,286.839,197.669Z",
    transform: "translate(-286.703 -195.13)",
    fill: "#f28f8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0 16.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M299.221,195.733c-2.95-.613-3.066-1.4-4.246-2.629-1.392-1.452-1.824-1.964-2.916-2.022a26.492,26.492,0,0,0-3.519.156,16.7,16.7,0,0,0-2.71.776c-.494.236-1.905,1.492-2.691,2.007s-1.125.775-.809,1.14,1.019.221,1.626.044a2.724,2.724,0,0,0,.994-.535s1.327-.476,1.4-.673l1.652-.186a10.377,10.377,0,0,0,1.657.031l-.007.053a.473.473,0,0,1-.269.37,4.806,4.806,0,0,1-1.51.4c-.774.05-1.1.109-1.9.131a10.019,10.019,0,0,0-2.083.116c-.488.146-.914.647-.289,1.343a2.841,2.841,0,0,0,2.178.857c.758.028,2.355-.239,2.814-.214a1.521,1.521,0,0,1,1.274.726,5.7,5.7,0,0,0,2.7,2.546c1.683.664,2.406.391,4.289.948Z",
    transform: "translate(-282.212 -191.068)",
    fill: "#ffa8a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(7.223 0.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M297.754,194.928a5.249,5.249,0,0,1,.623-1.8,2.843,2.843,0,0,0-.85,1.826Z",
    transform: "translate(-297.527 -193.127)",
    fill: "#f28f8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(14.639 0.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M340.155,157.266c-3.771,1.267-5.641,2.048-8.325,9.4-2.23,6.107-4.2,12.391-4.2,12.391a85.4,85.4,0,0,1-12.011-1.179,6.425,6.425,0,0,0-2.36,5.384s8.065,2.775,13.715,4.114c5.554,1.316,6.891.906,8.249-2.888,1.736-4.851,5.488-14.521,5.488-14.521Z",
    transform: "translate(-313.249 -157.266)",
    fill: "#ffa8a7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M358.125,156.93c-4.483.969-6.059,2.183-7.644,6.246-1.422,3.645-4.142,11.4-4.142,11.4s3.993,4.136,11.472,3.562l2.52-8.665Z",
    transform: "translate(-316.093 -156.93)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_",
    transform: "translate(8.189 25.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_893_",
    d: "M386.275,157.827a12.087,12.087,0,0,1,1.7,5.02,40.008,40.008,0,0,1-.268,9.668,63.371,63.371,0,0,0-.78,11.09l.281,11.9c-3.609,4.04-20.636,6.462-28.724.73,0,0,.06-24.019.809-30.458.552-4.752,1.955-9.138,5.25-9.994,2.241-.338,9.52-1.715,13.168-.593S386.275,157.827,386.275,157.827Z",
    transform: "translate(-330.697 -154.755)",
    fill: "#3e8cd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    d: "M386.275,157.827a12.087,12.087,0,0,1,1.7,5.02,40.008,40.008,0,0,1-.268,9.668,63.371,63.371,0,0,0-.78,11.09l.281,11.9c-3.609,4.04-20.636,6.462-28.724.73,0,0,.06-24.019.809-30.458.552-4.752,1.955-9.138,5.25-9.994,2.241-.338,9.52-1.715,13.168-.593S386.275,157.827,386.275,157.827Z",
    transform: "translate(-358.48 -154.755)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head_12_",
    transform: "translate(37.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M396.869,112.6s.989-.352,2.03,1.223c1.031,1.558.508,5.3-.173,8.539a24.293,24.293,0,0,1-1.941,5.915,2.455,2.455,0,0,1-1.383,1.188l-.038-3.814.047-2.66a10.935,10.935,0,0,1-2.038-4.17,6.832,6.832,0,0,1,.157-3.47Z",
    transform: "translate(-378.278 -106.644)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_890_",
    d: "M379.331,113.5a7.56,7.56,0,0,1-7.322,7.791c-4.173.13-7.117-3.138-7.247-7.311s2.6-7.672,6.777-7.8A7.56,7.56,0,0,1,379.331,113.5Z",
    transform: "translate(-363.218 -103.268)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M384.1,127.762a1.77,1.77,0,0,1-2.338-.418v7.88c-3.538,4.05-11.645,3.121-9.141-.431l-.008-1.8a14.616,14.616,0,0,1-2.765.079c-1.758-.213-2.9-1.563-3.494-3.437-.944-3.015-.9-7.592.07-13.54,1.906-1.585,8.328-2.041,12.531.425-.08,3.487.939,5,.976,6.265a3.313,3.313,0,0,0,.788.954c.659.533,1.132-.921,1.649-1.5a1.9,1.9,0,0,1,3.187.416C386.5,124.5,385.432,127.187,384.1,127.762Z",
    transform: "translate(-363.701 -107.82)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M363.273,104.181a1.519,1.519,0,0,1,1.107-1.08c.285-.065.583-.044.874-.084.675-.092.793-.555,1.087-1.076a2.034,2.034,0,0,1,1.16-.9,3.479,3.479,0,0,1,1.484-.1,1.8,1.8,0,0,1,1.254.574,3.762,3.762,0,0,1,1.609-1.384,2.733,2.733,0,0,1,.887-.12,2.657,2.657,0,0,1,1.173.234,1.833,1.833,0,0,1,.992,1.674,2.211,2.211,0,0,1,1.488-.34,2.8,2.8,0,0,1,1.908,1.176,2.439,2.439,0,0,1,.39,1.688,1.382,1.382,0,0,1,1.334.182,1.694,1.694,0,0,1,.54,1.314,11.5,11.5,0,0,1-3.753,2.746.922.922,0,0,1-.449.715,1.754,1.754,0,0,1-.836.235,2.133,2.133,0,0,1-.933-.139c-.284-.116-.5-.467-.784-.292s-.5.45-.812.607a2.268,2.268,0,0,1-.913.244,1.78,1.78,0,0,1-1.777-1.169,2.2,2.2,0,0,1-1.565,1.017,2.461,2.461,0,0,1-1.723-.427,1.667,1.667,0,0,1-.595-1.238,1.571,1.571,0,0,1-1.678-.166,1.376,1.376,0,0,1-.364-1.614,1.981,1.981,0,0,1-2.745-.369.478.478,0,0,1-.132-.376,1.048,1.048,0,0,0,1.6-.45,7.271,7.271,0,0,0,.173-1.059C363.269,104.2,363.271,104.189,363.273,104.181Z",
    transform: "translate(-361.494 -100.013)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_",
    transform: "translate(3.046 11.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_888_",
    d: "M383.557,124.743l1.66.953a1,1,0,0,0-.368-1.34A.934.934,0,0,0,383.557,124.743Z",
    transform: "translate(-376.197 -123.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_887_",
    d: "M367.991,124.627l1.832-.6a.925.925,0,0,0-1.185-.633A1.013,1.013,0,0,0,367.991,124.627Z",
    transform: "translate(-367.953 -123.344)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M383.463,129.6a.78.78,0,1,1-.78-.78A.78.78,0,0,1,383.463,129.6Z",
    transform: "translate(-375.324 -126.239)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M370.172,128.833a.78.78,0,1,1-.78-.78A.71.71,0,0,1,370.172,128.833Z",
    transform: "translate(-368.302 -125.832)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_886_",
    d: "M374.414,126.458l-.725,5.361-2.63-.911A9.861,9.861,0,0,1,374.414,126.458Z",
    transform: "translate(-369.594 -124.989)",
    fill: "#f28f8f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M379.391,128.289c-.238,3.737-1.481,4.836-2.771,5.224-2.055.618-3.49-.666-5.895-1.1a7.363,7.363,0,0,0-3.814.6c-.217.064-.468.123-.708.174a.828.828,0,0,1-.995-.748,44.748,44.748,0,0,1,0-5.187l-.351-1.194a57.041,57.041,0,0,0-.2,7.841c.166,1.77.671,3.723,2.2,4.626,1.567.923,3.371.844,6.965.557,3.9-.311,5.445-1.954,5.888-3.19,1.439-4.011.929-5.928,1.4-6.683S379.391,128.289,379.391,128.289Z",
    transform: "translate(-363.123 -113.777)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_878_",
    d: "M378.971,142.514l-2.337.6a1.185,1.185,0,0,0,1.446.908A1.263,1.263,0,0,0,378.971,142.514Z",
    transform: "translate(-369.493 -122.468)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M379.884,143.34a1.325,1.325,0,0,1,.292-.008,1.247,1.247,0,0,1-.914,1.122,1.141,1.141,0,0,1-.385.027A1.1,1.1,0,0,1,379.884,143.34Z",
    transform: "translate(-370.675 -122.898)",
    fill: "#f28f8f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(56.901 29.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M422.091,183.074c-1.847-6.068-3.823-10.949-5.209-14.765-1.817-5-4.188-5.914-7.921-6.688-2.173,1.256-3.218,6.435-.448,12.241,1.721,4.28,5.427,13.223,5.427,13.223-.247,1.245-1.392,9.281-2.807,12.657a3.417,3.417,0,0,1-2.251,1.891c-1.487.576-2.375,2.379-3.556,3.261-.924.691-1.584.856-1.524,1.135.076.358.687.682,1.7.589a4.718,4.718,0,0,0,1.966-.646,5.725,5.725,0,0,1,.882-.561c.475-.173.418.259.333.568a6.4,6.4,0,0,1-.76,1.506,18.506,18.506,0,0,1-1.605,2.329,9.172,9.172,0,0,1-1.472,1.357,11.89,11.89,0,0,0-1.542,1.481c-.2.221-.513.6-.445.92.081.387.59.488.92.433.315-.051.612-.193.929-.226.659-.069,1.3.337,1.96.26a5.967,5.967,0,0,0,.706-.178,5,5,0,0,1,1.126-.1,2.578,2.578,0,0,0,.914-.072c.29-.115.583-.227.873-.344l2.221-.9a2.952,2.952,0,0,0,1.168-1.163,21.228,21.228,0,0,0,2.978-6.378c.784-2.832,3.686-9.408,4.61-12.878C422.77,186.39,422.877,185.657,422.091,183.074Z",
    transform: "translate(-402.852 -161.621)",
    fill: "#ffa8a7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M412.374,160.47a14.046,14.046,0,0,1,5.62,2.691c1.508,1.335,1.745,1.966,3.05,4.849,1.276,2.818,3.974,10.344,3.974,10.344a10.411,10.411,0,0,1-9.334,4.114l-4.491-9.53S408.272,165.446,412.374,160.47Z",
    transform: "translate(-349.825 -131.955)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M343.739,202.536a3.617,3.617,0,0,1,3.28,3.29,3.583,3.583,0,0,0-3.008-4.114Z",
    transform: "translate(-314.719 -153.745)",
    fill: "#f28f8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(58.098 113.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M25.435,0A25.435,25.435,0,1,0,50.87,25.435,25.435,25.435,0,0,0,25.435,0ZM3.809,25.435A21.628,21.628,0,0,1,39.16,8.72L8.991,39.482A21.466,21.466,0,0,1,3.809,25.435ZM40.727,40.727A21.63,21.63,0,0,1,11.71,42.15L41.879,11.388a21.627,21.627,0,0,1-1.152,29.339Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 3.549, 0)",
    fill: "#fab21f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(15.194 8.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M267.01,158.614a2.005,2.005,0,1,0-4.011,0v8.473L267.01,163Z",
    transform: "translate(-248.779 -154.482)",
    fill: "#304b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M194.886,154.25v-7.863a1.975,1.975,0,1,0-3.95,0v6.805c0,.01,0,.02,0,.031v7.705a.486.486,0,0,1-.972,0V148.394a1.855,1.855,0,0,0-3.71,0v8.289l0,0v4.449a.575.575,0,1,1-1.15,0v-9.484a1.823,1.823,0,1,0-3.646,0v19.233c0,.208.008.414.02.619l13.41-13.674V154.25Z",
    transform: "translate(-181.456 -144.412)",
    fill: "#304b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M208.135,223.567v-4.736L191.688,235.6a10.361,10.361,0,0,0,18.938-5.814l4.986-11.073a2.005,2.005,0,1,0-3.539-1.887l-3.938,7.385a7.178,7.178,0,0,0-6.677,7.152.322.322,0,0,1-.645,0A7.824,7.824,0,0,1,208.135,223.567Z",
    transform: "translate(-189.904 -203.322)",
    fill: "#304b54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(27.06 9.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(7.223 24.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M290.92,294.125a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,290.92,294.125Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,290.92,293.253Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,290.92,292.381Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,290.92,291.509Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,290.92,290.637Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,290.92,289.765Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.086.086,0,0,1,290.92,288.893Z",
    transform: "translate(-290.92 -288.806)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(8.135 23.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M296.15,288.375a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,296.15,288.375Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,296.15,287.5Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,296.15,286.631Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.088.088,0,0,1-.087.087h0A.088.088,0,0,1,296.15,285.759Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,296.15,284.887Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,296.15,284.015Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,296.15,283.143Z",
    transform: "translate(-296.15 -283.056)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(4.94 2.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M277.83,167.912a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,167.912Zm0-.872a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,167.04Zm0-.872a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,166.168Zm0-.872a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,165.3Zm0-.872a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,164.424Zm0-.872a.087.087,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,277.83,163.552Z",
    transform: "translate(-277.83 -163.465)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(0.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M254.36,156.807a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,156.807Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,155.935Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,155.063Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,154.191Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,153.319Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,152.447Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,151.575Zm0-.872a.086.086,0,0,1,.087-.087h0a.087.087,0,0,1,.087.087h0a.089.089,0,0,1-.087.087h0A.088.088,0,0,1,254.36,150.7Z",
    transform: "translate(-254.36 -150.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(5.854 2.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M283.07,168.8a.086.086,0,0,1,.085-.087h0a.088.088,0,0,1,.089.087h0a.087.087,0,0,1-.089.085h0A.086.086,0,0,1,283.07,168.8Zm0-.872a.086.086,0,0,1,.085-.087h0a.088.088,0,0,1,.089.087h0a.089.089,0,0,1-.089.087h0A.087.087,0,0,1,283.07,167.927Zm0-.874a.086.086,0,0,1,.085-.085h0a.088.088,0,0,1,.089.085h0a.089.089,0,0,1-.089.089h0A.087.087,0,0,1,283.07,167.053Zm0-.87a.086.086,0,0,1,.085-.087h0a.088.088,0,0,1,.089.087h0a.087.087,0,0,1-.089.085h0A.086.086,0,0,1,283.07,166.183Z",
    transform: "translate(-283.07 -166.096)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(0 1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M249.5,162.4a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,249.5,162.4Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.087.087,0,0,1,249.5,161.531Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.087.087,0,0,1,249.5,160.659Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,249.5,159.787Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.086.086,0,0,1-.087.087h0A.086.086,0,0,1,249.5,158.915Zm0-.872a.086.086,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.087.087,0,0,1,249.5,158.043Z",
    transform: "translate(-249.5 -157.956)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(6.309 25.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M285.68,303.673a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,303.673Zm0-.872a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,302.8Zm0-.872a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,301.929Zm0-.872a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,301.057Zm0-.872a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,300.185Zm0-.872a.087.087,0,0,1,.087-.087h0a.086.086,0,0,1,.087.087h0a.087.087,0,0,1-.087.087h0A.089.089,0,0,1,285.68,299.313Z",
    transform: "translate(-285.68 -299.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(8.826 15.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M300.162,244.325a.088.088,0,0,1-.045-.115h0a.086.086,0,0,1,.113-.045h0a.087.087,0,0,1,.047.115h0a.088.088,0,0,1-.08.052h0A.083.083,0,0,1,300.162,244.325Zm.344-.8a.086.086,0,0,1-.045-.113h0a.087.087,0,0,1,.113-.047h0a.088.088,0,0,1,.047.115h0a.087.087,0,0,1-.08.052h0A.087.087,0,0,1,300.505,243.522Zm.344-.8a.089.089,0,0,1-.046-.115h0a.088.088,0,0,1,.115-.045h0a.086.086,0,0,1,.045.113h0a.089.089,0,0,1-.08.054h0A.116.116,0,0,1,300.849,242.722Zm.343-.8a.086.086,0,0,1-.045-.113h0a.086.086,0,0,1,.113-.047h0a.087.087,0,0,1,.047.115h0a.088.088,0,0,1-.08.052h0A.078.078,0,0,1,301.192,241.92Zm.344-.8a.086.086,0,0,1-.045-.113h0a.086.086,0,0,1,.113-.045h0a.086.086,0,0,1,.047.113h0a.089.089,0,0,1-.08.054h0A.08.08,0,0,1,301.536,241.117Zm.344-.8a.088.088,0,0,1-.045-.115h0a.087.087,0,0,1,.113-.045h0a.089.089,0,0,1,.047.115h0a.087.087,0,0,1-.08.052h0A.078.078,0,0,1,301.879,240.317Zm.344-.8a.086.086,0,0,1-.046-.113h0a.085.085,0,0,1,.113-.045h0a.087.087,0,0,1,.047.113h0a.088.088,0,0,1-.08.052h0A.084.084,0,0,1,302.223,239.515Zm.344-.8a.088.088,0,0,1-.045-.115h0a.086.086,0,0,1,.113-.045h0a.089.089,0,0,1,.047.115h0a.089.089,0,0,1-.08.052h0A.08.08,0,0,1,302.566,238.714Zm.344-.8a.084.084,0,0,1-.045-.113h0a.087.087,0,0,1,.113-.047h0a.087.087,0,0,1,.045.115h0a.085.085,0,0,1-.078.052h0A.08.08,0,0,1,302.91,237.912Zm.344-.8a.086.086,0,0,1-.046-.115h0a.086.086,0,0,1,.113-.045h0a.085.085,0,0,1,.045.113h0a.086.086,0,0,1-.078.054h0A.075.075,0,0,1,303.254,237.112Z",
    transform: "translate(-300.109 -236.944)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(8.826 17.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M300.162,257.029a.088.088,0,0,1-.045-.115h0a.088.088,0,0,1,.115-.045h0a.088.088,0,0,1,.045.115h0a.089.089,0,0,1-.08.052h0A.078.078,0,0,1,300.162,257.029Zm.352-.8a.088.088,0,0,1-.044-.115h0a.086.086,0,0,1,.115-.045h0a.088.088,0,0,1,.044.115h0a.087.087,0,0,1-.08.052h0A.118.118,0,0,1,300.514,256.232Zm.354-.8a.088.088,0,0,1-.045-.115h0a.088.088,0,0,1,.115-.044h0a.088.088,0,0,1,.045.115h0a.092.092,0,0,1-.08.052h0A.078.078,0,0,1,300.868,255.433Zm.352-.8a.087.087,0,0,1-.044-.115h0a.087.087,0,0,1,.115-.044h0a.087.087,0,0,1,.044.115h0a.087.087,0,0,1-.08.051h0A.091.091,0,0,1,301.22,254.636Zm.354-.8a.089.089,0,0,1-.045-.115h0a.086.086,0,0,1,.115-.044h0a.088.088,0,0,1,.045.115h0a.09.09,0,0,1-.08.051h0A.079.079,0,0,1,301.574,253.839Zm.352-.8a.088.088,0,0,1-.044-.115h0a.088.088,0,0,1,.115-.045h0a.09.09,0,0,1,.044.117h0a.086.086,0,0,1-.08.051h0A.086.086,0,0,1,301.926,253.042Zm.354-.8a.089.089,0,0,1-.046-.115h0a.089.089,0,0,1,.115-.046h0a.087.087,0,0,1,.045.115h0a.087.087,0,0,1-.08.052h0A.084.084,0,0,1,302.281,252.245Zm.352-.8a.088.088,0,0,1-.044-.115h0a.087.087,0,0,1,.115-.045h0a.088.088,0,0,1,.044.115h0a.085.085,0,0,1-.078.052h0A.144.144,0,0,1,302.633,251.448Zm.354-.8a.086.086,0,0,1-.045-.113h0a.087.087,0,0,1,.115-.045h0a.087.087,0,0,1,.045.115h0a.088.088,0,0,1-.08.052h0A.082.082,0,0,1,302.987,250.65Z",
    transform: "translate(-300.109 -250.484)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "X_3_",
    d: "M374.676,64.04l7.087-5.358-7.374-14.09a2.678,2.678,0,0,1,4.745-2.483l6.961,13.3,6.374-4.818a2.678,2.678,0,0,1,3.23,4.271l-7.087,5.358,7.061,13.493a2.678,2.678,0,1,1-4.745,2.483l-6.648-12.7-6.374,4.819a2.678,2.678,0,0,1-3.23-4.272Z",
    transform: "translate(91.93 491.681)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeniedGraphics);
export default __webpack_public_path__ + "static/media/icon_denied_graphics.3c942a64c10fb882fb6653fdf9562ea1.svg";
export { ForwardRef as ReactComponent };